module.exports = __webpack_public_path__ + "img/login_page_logo.1027b887.svg";